module.exports = __webpack_public_path__ + "static/media/findStore.295863b1.png";